<template>
    <div class="data-screen column height-100p" @click="triggerFullScreen">
        <div class="row height-75 top">
            <div class="top-left row align-items-center">
                <img class="margin-left-20 margin-right-10" src="./images/logo.svg" alt="">
                <span class="support">森果技术支持</span>
                <span class="font-size-24 color-fff">-农鼎慧</span>
            </div>
            <div class="top-center">
                <h1>{{chain_shop.name}}</h1>
            </div>
            <div class="top-right row justify-content-flex-end align-items-center">
                <span>{{dayJs(currentTime).format('YYYY-MM-DD')}}</span>
                <span class="margin-left-20 margin-right-30">{{dayJs(currentTime).format('HH:mm:ss')}}</span>
            </div>
        </div>
        <div class="expaned content row padding-top-30 overflow-hidden">
            <div class="left column">
                <div class="row space-between">
                    <div class="goods-data width-210 height-120">
                        <div class="title row align-items-center"><i></i>上架商品数</div>
                        <div class="amout">{{goods_count}}</div>
                    </div>
                    <div class="stock-data width-210 height-120">
                        <div class="title row align-items-center"><i></i>库存总量</div>
                        <div class="amout">{{goods_stock_sum}}</div>
                    </div>
                </div>
                <h2 class="margin-top-40 margin-bottom-24">商品均价</h2>
                <div class="expaned padding-bottom-30 overflow-hidden hidden-scrollbar" id="scrollDom" v-autoScroll>
                    <div class="goods-item row align-items-center space-between" v-for="(item, index) in goodsList" :key="index">
                        <div class="row align-items-center expaned overflow-hidden">
                            <img :src="item.img ? getQiniuImgUrl(item.img) : noGoodsImg" alt="">
                            <div class="column margin-left-20 justify-content-center overflow-hidden">
                                <span class="goods-name">{{item.name}}</span>
                                <span class="date">{{dayJs(item.update_time).format('YYYY-MM-DD')}}</span>
                            </div>
                        </div>
                        <div class="price margin-right-30 white-space-nowrap">
                            <span>{{item.avg_price}}</span>/<span>{{item.unit_name}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 中间部分 -->
            <div class="column center-box expaned margin-left-30">
                <div class="top-box">商户经营信息</div>
                <div class="content-box column expaned">
                    <div class="top-title row">
                        <div>商户名称</div>
                        <div>经营类别</div>
                        <div>农残检测/合规经营</div>
                    </div>
                    <div class="expaned table-box overflow-hidden" v-autoScroll>
                        <div class="item" v-for="(item, index) in shopList" :key="index">
                            <div>{{item.name}}</div>
                            <div>{{item.typeName}}</div>
                            <div>合格</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $fetch from '@/api'
import dayjs from 'dayjs'
import { openMessage } from '@/utils/system'
import { qiniuImageURLPrefix, getQiniuImgUrl } from '@/assets/ts/qiniu'
import { setObjectItemToFixed } from '@/utils/index'
import shopList from './shop_list'
import noGoodsImg from './images/no-goods-img.png'

function autoScroll(el) {
    clearInterval(el.scrollTimer)
    if (el.scrollHeight > el.clientHeight) {
        const oldClone = el.getElementsByClassName('clone')
        if (oldClone.length > 0 && el.contains(oldClone[0])) {
            el.removeChild(oldClone[0])
        }
        const cloneDiv = document.createElement('div')
        cloneDiv.className = "clone"
        Array.from(el.children).forEach(el => cloneDiv.appendChild(el.cloneNode(true)))
        el.appendChild(cloneDiv)
        el.scrollTimer = setInterval(() => {
            if (Math.floor(el.scrollTop) === Math.floor(el.scrollHeight / 2)) {
                el.scrollTop = 16
            } else if (el.scrollHeight > el.scrollTop + el.clientHeight) {
                el.scrollTop = el.scrollTop + 1
            }
        }, 32);
    }
}

export default {
    data() {
        return {
            chain_shop: {},
            goods_count: 0, // 上架商品数
            goods_stock_sum: 0, // 库存总量
            goodsList: [],
            shopList: shopList,
            currentTime: new Date()
        }
    },

    created() {
        this.qiniuImageURLPrefix = qiniuImageURLPrefix
        this.noGoodsImg = noGoodsImg
        this.shopId = this.$route.query.shopId
        this.getShopInfo()
        this.getbranchdata()
        this.timer = setInterval(() => {
            this.getbranchdata()
        }, 60 * 1000);
        this.timeInterval = setInterval(() => {
            this.currentTime = new Date()
        }, 1000);
    },

    mounted() {
        setTimeout(() => {
            document.getElementById('senguo-feedback-a5j6f9k2').remove()
        }, 10000)
        document.documentElement.webkitRequestFullscreen()
    },

    beforeDestroy() {
        clearInterval(this.timer)
        clearInterval(this.timeInterval)
    },

    directives: {
        autoScroll: {
            inserted: function(el) {
                autoScroll(el)
            },

            componentUpdated: function(el) {
                autoScroll(el)
            },

            unbind: function(el) {
                clearInterval(el.scrollTimer)
            }
        }
    },

    methods: {
        dayJs: dayjs,
        getbranchdata() {
            $fetch.post({
                url: '/chain/getbranchdata',
                params: {
                    chain_shop_uid: this.shopId // '74b42db82ef74da5ae78ac1bd15efe20'
                }
            }).then(data => {
                // this.genarate7DaysData(data.map(val => val.order_subtotal_sum))
                this.goods_count = data.goods_count
                this.goodsList = data.goods_data_list
                this.goods_stock_sum = data.goods_stock_sum
            }).catch(e => {
                openMessage("error", e.message)
            })
        },

        triggerFullScreen() {
            if (this.isFullScreen()) {
                this.exitFullscreen()
            } else {
                this.full(document.documentElement)
            }
        },

        full(ele) {
            if (ele.requestFullscreen) {
                ele.requestFullscreen();
            } else if (ele.mozRequestFullScreen) {
                ele.mozRequestFullScreen();
            } else if (ele.webkitRequestFullscreen) {
                ele.webkitRequestFullscreen();
            } else if (ele.msRequestFullscreen) {
                ele.msRequestFullscreen();
            }
        },

        exitFullscreen() {
            if(document.exitFullScreen) {
                document.exitFullScreen();
            } else if(document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if(document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if(document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        },

        isFullScreen() {
            return  !! (
                document.fullscreen || 
                document.mozFullScreen ||                         
                document.webkitIsFullScreen ||       
                document.webkitFullScreen || 
                document.msFullScreen 
            );
        },

        getShopInfo() {
            $fetch.post({
                url: '/chain/getchainshopbyuid',
                params: {
                    uid: this.shopId, // '74b42db82ef74da5ae78ac1bd15efe20'
                }
            }).then(data => {
                this.chain_shop = data.chain_shop
                // this.shop_count = data.branch_shop_count
                // this.shopList = data.shop_goods_info_response
            }).catch(e => {
                openMessage("error", e.message)
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.data-screen {
    background-image: url("./images/bg.jpg");
    background-size: 100% 100%;
    padding: 0 30px 30px 30px;
}

.top {
    align-items: flex-end;
    // padding: 0 30px;
    padding-bottom: 6px;
    justify-content: space-between;

    .top-left {
        flex: 1;
        max-width: 690px;
        height: 50px;   
        background: url('./images/haderleft1.svg') no-repeat, url('./images/headerright1.svg') no-repeat;
        background-position: left center, right center;

        span {
            font-family: PingFangSC-Medium;
            font-size: 24px;
            color: #FFFFFF;
            letter-spacing: 7.69px;
            text-align: center;
            // text-shadow: 0 0 4px rgba(70,255,194,0.26);
            line-height: 60px;
        }

        .support {
            background-image: -webkit-linear-gradient(bottom, #a2ffe6, #22f7bf);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }

    .top-center {
        overflow: hidden;
        width: 480px;
        height: 60px;
        margin: 0 30px;
        background-image: url("./images/headerleft2.svg"), url("./images/top-center-item-1.svg"), url('./images/headerright2.svg');
        background-repeat: no-repeat;
        background-position: left center, center 0, right center;

        font-family: PingFangSC-Medium;
        font-size: 25px;
        color: #FFFFFF;
        letter-spacing: 7.69px;
        text-align: center;
        text-shadow: 0 0 4px rgba(70,255,194,0.26);
        line-height: 60px;
        // background-size: cover;
    }

    .top-right {
        flex: 1;
        max-width: 690px;
        // background-image: url("./images/top-right.svg");
        height: 50px;
        // background-size: 100% 100%;
        background: url('./images/haderleft1.svg') no-repeat, url('./images/headerright1.svg') no-repeat;
        background-position: left center, right center;

        span {
            font-family: PingFangSC-Medium;
            font-size: 20px;
            color: #FFFFFF;
            text-shadow: 0 0 4px rgba(70,255,194,0.26);
        }
    }
}

.content {
    .left {
        width: 450px;

        .goods-data {
            padding: 20px;
            width: 210px;
            background-image: url("./images/goods-count-bg.svg");
            background-size: 100% 100%;

            .title {
                font-family: PingFangSC-Medium;
                font-size: 15px;
                color: #FFFFFF;
                line-height: 21px;

                i {
                    margin-right: 10px;
                    height: 12px;
                    width: 2px;
                    background: #14CC9B;
                }
                
            }

            .amout {
                margin-top: 13px;
                margin-left: 12px;
                font-family: dataScreenNumber;
                font-size: 40px;
                color: #22FFC4;
            }
        }

        .stock-data {
            padding: 20px;
            width: 210px;
            background-image: url("./images/stock-bg.svg");
            background-size: 100% 100%;

            .title {
                font-family: PingFangSC-Medium;
                font-size: 15px;
                color: #FFFFFF;
                line-height: 21px;

                i {
                    margin-right: 10px;
                    height: 12px;
                    width: 2px;
                    background: #14CC9B;
                }
            }

            .amout {
                margin-top: 13px;
                margin-left: 12px;
                font-family: dataScreenNumber;
                font-size: 40px;
                color: #22FFC4;
            }
        }
        
        h2 {
            font-family: PingFangSC-Medium;
            font-size: 15px;
            color: #D4D4D4;
        }

        .goods-item {
            position: relative;
            margin-bottom: 20px;
            width: 450px;
            height: 62px;
            background: #0D120E;
            background-image: linear-gradient(144deg, #121914 0%, #030903 100%);
            border-radius: 12px;
            border: 1px solid rgb(16, 95, 72);

            &::after {
                content: "";
                position: absolute;
                right: 0;
                top: 50%;
                height: 11px;
                width: 2px;
                background: #14CC9B;
                transform: translateY(-50%);
            }

            img {
                margin-left: 6px;
                width: 50px;
                height: 50px;
                border-radius: 12px;
            }

            .goods-name {
                font-family: PingFangSC-Medium;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 28px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .date {
                // margin-top: 4px;
                font-family: PingFangSC-Semibold;
                font-size: 12px;
                line-height: 17px;
                color: #D1D1D1;
            }

            .price {
                color: #fff;
                font-size: 20px;
                span {
                    &:nth-of-type(1) {
                        font-family: dataScreenNumber;
                        font-size: 20px;
                        color: #22FFC4;
                        line-height: 24px;
                    }

                    &:nth-of-type(2) {
                        font-family: PingFangSC-Semibold;
                        font-size: 12px;
                        color: #FFFFFF;
                        line-height: 17px;
                    }
                }
            }
        }
    }

   
}

.center-box {
    // background-image: url("./images/d1.svg");
    border: 1px solid #00D39B;
    border-top: 0;
    border-radius: 10px;
    backdrop-filter: brightness(70%);

    .top-box {
        // width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
        // background-image: url("./images/d2.svg");
        border: 1px solid #00D39B;
        font-family: PingFangSC-Medium;
        border-radius: 10px;
        font-size: 20px;
        color: #FFFFFF;
    }

    .content-box {
        padding: 0 30px;
        overflow: hidden;
        .top-title {
            display: flex;
            align-items: center;
            flex-shrink: 0;
            width: 100%;
            height: 60px;
            font-family: PingFangSC-Medium;
            font-size: 15px;
            color: #D4D4D4;

            > div {
                flex: 1;
                padding: 0 30px;

                &:nth-of-type(1) {

                }
                &:nth-of-type(2) {
                    text-align: center;
                }
                &:nth-of-type(3) {
                    text-align: right;
                }
            }
        }

        .table-box {

            .item {
                display: flex;
                align-items: center;
                height: 88px;
                font-family: PingFangSC-Medium;
                font-size: 20px;
                color: #FFFFFF;
                text-align: center;
                padding: 0 30px;
                border-bottom:  1px solid #455745;

                > div {
                    flex: 1;

                    &:nth-of-type(1) {
                        text-align: left;
                    }
                    &:nth-of-type(2) {
                        text-align: center;
                    }
                    &:nth-of-type(3) {
                        text-align: right;
                        font-family: PingFangSC-Medium;
                        color: #14CC9B;
                    }
                }
            }
        }
    }

}
</style>